import React from 'react'

import SvgIcon from '@mui/material/SvgIcon'
import useTheme from '@mui/material/styles/useTheme'

const DescendIcon = (): JSX.Element => {
  const theme = useTheme()
  return (
    <SvgIcon viewBox="0 0 21 32">
      <path
        d="M11.9926 16.6625L9.53258 14.2025C9.14258 13.8125 8.51258 13.8125 8.12258 14.2025C7.73258 14.5925 7.73258 15.2225 8.12258 15.6125L11.2926 18.7925C11.6826 19.1825 12.3126 19.1825 12.7026 18.7925L15.8726 15.6225C16.2626 15.2325 16.2626 14.6025 15.8726 14.2125C15.4826 13.8225 14.8526 13.8225 14.4626 14.2125L11.9926 16.6625Z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M14.4626 9.79253L12.0026 7.33253L9.53258 9.79253C9.14258 10.1825 8.51258 10.1825 8.12258 9.79253C7.73258 9.40253 7.73258 8.77253 8.12258 8.38253L11.2926 5.20253C11.6826 4.81253 12.3126 4.81253 12.7026 5.20253L15.8726 8.38253C16.2626 8.77253 16.2626 9.40253 15.8726 9.79253C15.4826 10.1825 14.8526 10.1825 14.4626 9.79253Z"
        fill={theme.palette.primary.lighter}
      />
    </SvgIcon>
  )
}
export default DescendIcon
